export default __webpack_public_path__ + "static/media/latest-news-header-img-03.42ab080e.jpg";